import { getEnvVariable } from '../envs';
/** Primary keys used by ONESTOP auth / portal (aliases checked below). */
function buildCandidates(prefix) {
    const moduleKey = String(getEnvVariable('ModuleKey') || getEnvVariable('AppModuleKey') || '');
    const titleKeyRaw = String(getEnvVariable('TitleKey') || getEnvVariable('Title') || '');
    const normalize = (s) => (s ? s.replace(/\s+/g, '_').replace(/[^A-Za-z0-9_]/g, '') : '');
    const titleKey = normalize(titleKeyRaw);
    const candidates = [];
    // prefer most specific: module + title
    if (moduleKey && titleKey)
        candidates.push(`${prefix}_${moduleKey}_${titleKey}`);
    candidates.push(prefix);
    return candidates;
}
// Backwards-compatible single-key constants (legacy code expects the simple prefix).
export const AUTH_TOKEN_KEYS = {
    internal: 'internaltoken',
    external: 'externaltoken',
};
// Export the full candidate lists for new logic to check environment-specific keys.
export const AUTH_TOKEN_CANDIDATES = {
    get internal() { return buildCandidates('internaltoken'); },
    get external() { return buildCandidates('externaltoken'); },
};
function readFirst(storage, keys) {
    for (const k of keys) {
        const v = storage.getItem(k)?.trim();
        if (v)
            return v;
    }
    return '';
}
/**
 * Returns the first non-empty value whose key STARTS WITH `prefix`. Handles dynamic token keys whose
 * module/title suffix is not known ahead of time (e.g. `internaltoken_APPS_ONESTOP`) — matching just the
 * `internaltoken` / `externaltoken` prefix instead of an exact, pre-computed key.
 */
function readFirstByPrefix(storage, prefix) {
    try {
        for (let i = 0; i < storage.length; i++) {
            const key = storage.key(i);
            if (key && key.startsWith(prefix)) {
                const v = storage.getItem(key)?.trim();
                if (v)
                    return v;
            }
        }
    }
    catch {
        /* ignore */
    }
    return '';
}
/** Reads a token by exact env-derived candidates first, then falls back to a prefix scan (dynamic suffix). */
function readToken(prefix) {
    return (readFirst(localStorage, buildCandidates(prefix)) ||
        readFirst(sessionStorage, buildCandidates(prefix)) ||
        readFirstByPrefix(localStorage, prefix) ||
        readFirstByPrefix(sessionStorage, prefix));
}
/**
 * True if at least one auth token is present. ONESTOP often sets only `internaltoken`;
 * requiring both internal+external caused the login dialog to open even when internal was set.
 */
export function hasAuthTokens() {
    try {
        return Boolean(readToken('internaltoken') || readToken('externaltoken'));
    }
    catch {
        return false;
    }
}
/** True when `internaltoken` / `internalToken` is set (NavBar hides Login). */
export function hasInternalAuthToken() {
    try {
        return Boolean(readToken('internaltoken'));
    }
    catch {
        return false;
    }
}
/**
 * Clears portal storage so Logout removes ONESTOP tokens and related keys.
 * Clears **localStorage** per product requirement; also **sessionStorage** because tokens may live there.
 */
export function clearPortalAuthStorage() {
    try {
        localStorage.clear();
    }
    catch {
        /* ignore quota / privacy mode */
    }
    try {
        sessionStorage.clear();
    }
    catch {
        /* ignore */
    }
}
